<template lang="pug">
	div
		.card
			.card-header.bg-info.text-white
				span.fa.fa-filter.mr-2
				| Buscador
			.card-body
				.row
					.col-xs-12.col-sm-12.col-md-4.col-lg-3.col-xl-3
						.form-group
							label Usuario
							input.form-control.form-control-sm(
								v-if="!permisos.gestion_jornada_verTodos"
								:value="usuario.nombre + ' ' + usuario.apellidos"
								disabled
							)
							input-query(
								v-else-if="permisos.gestion_jornada_verTodos && !filtro.UsuarioID"
								:realtime="true"
								url="gestion-jornada/php/api/queryUsuarios.php"
								@selected="seleccionaUsuario($event)"
								inputClass="form-control form-control-sm"
							)
							.input-group.input-group-sm(v-else)
								input.form-control.form-control-sm(
									:value="UsuarioNombre"
									disabled
								)
								.input-group-append
									button.btn.btn-sm.btn-danger(@click="filtro.UsuarioID = null")
										span.fa.fa-trash
					.col-xs-12.col-sm-12.col-md-4.col-lg-3.col-xl-3
						.form-group
							label Mes
							datepicker(
								v-model="fecha"
								:bootstrap-styling="true"
								minimum-view="month"
								format="MMMM, yyyy"
								:language="$dateLang"
							)
					.col-xs-12.col-sm-12.col-md-4.col-lg-3.col-xl-3
						.form-group
							label Tipo de jornada
							br
							.btn-group
								button.btn.btn-sm(
									@click="setTipo(tipo)"
									:class="(filtro.tipoJornada === tipo) ? 'btn-primary' : ''"
									v-for="tipo in TiposJornada"
									:key="tipo"
								) {{tipo}}

					.col-xs-12.col-sm-12.col-md-4.col-lg-3.col-xl-3(v-if="resultados.length > 0")
						.form-group
							label Vista
							br
							.btn-group
								button.btn.btn-sm(
									@click="filtro.vista = tipo"
									:class="(filtro.vista === tipo) ? 'btn-primary' : ''"
									v-for="tipo in TiposVista"
									:key="tipo"
								) {{tipo}}
			.card-footer
				button.btn.btn-primary(@click="buscar")
					span.fa.fa-search.mr-2
					| Buscar
</template>

<script>
import { mapGetters } from 'vuex'
import Editor from '../editor/editor'
export default {
	props: ['filtro', 'resultados'],
	components: {
		Editor
	},
	data () {
		return {
			fecha: new Date(),
			UsuarioNombre: null,
			editor: {
				tipoJornada: null,
				registroId: null
			},
			TiposJornada: [
				'Todos',
				'Trabajo',
				'Falta',
				'Libre',
				'Vacaciones'
			],
			TiposVista: [
				'Normal',
				'Agrupada'
			]
		}
	},
	created () {
		this.filtro.UsuarioID = this.usuario.ID
		this.UsuarioNombre = this.usuario.nombre + ' ' + this.usuario.apellidos
	},
	computed: {
		...mapGetters({
			usuario: 'session/usuario',
			permisos: 'permisos/permisos'
		})
	},
	watch: {
		fecha: function (newVal) {
			this.filtro.fecha = this.$moment(this.fecha).format('YYYY-MM-DD')
			this.buscar()
		}
	},
	methods: {
		seleccionaUsuario (ev) {
			this.filtro.UsuarioID = ev.datos.ID
			this.UsuarioNombre = ev.datos.nombre + ' ' + ev.datos.apellidos
			this.buscar()
		},
		setTipo (tipo) {
			this.filtro.tipoJornada = tipo
			this.buscar()
		},
		buscar () {
			this.$emit('buscar')
		},
		nuevo () {
			this.$emit('nuevo')
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/gestion-jornada/vue/components/listados/formulario.vue